import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { localStorageUtil } from '../utils';
import { ELocalStorageKeys } from '../constants/enums';
import { BootResponse } from '../constants/apiResponses.types';

interface InstallPromptEvent extends Event {
    prompt: () => Promise<void>;
}

const useSaveToHomePage = (publisherMetaData: BootResponse) => {
    const [useSaveToHomePageNotification, setUseSaveToHomePageNotification] =
        useState(false);
    const [isSaveToHomePageOpen, setIsSaveToHomePageOpen] = useState(false);
    const [installPrompt, setInstallPrompt] =
        useState<InstallPromptEvent | null>(null);
    const location = useLocation();

    useEffect(() => {
        const handleBeforeInstallPrompt = (e: any) => {
            e.preventDefault();
            setInstallPrompt(e);
        };

        window.addEventListener(
            'beforeinstallprompt',
            handleBeforeInstallPrompt
        );

        return () => {
            window.removeEventListener(
                'beforeinstallprompt',
                handleBeforeInstallPrompt
            );
        };
    }, []);

    const handleInstallApp = () => {
        if (installPrompt) {
            installPrompt.prompt().then(() => {
                setInstallPrompt(null);
            });
        }
    };

    useEffect(() => {
        setUseSaveToHomePageNotification(
            !!publisherMetaData.featureFlags
                ?.store_add_to_home_screen_notification
        );
    }, [publisherMetaData]);

    useEffect(() => {
        const checkSaveToHomePageStatus = () => {
            const isPopUpOpened = localStorageUtil.get(
                ELocalStorageKeys.IS_SAVE_TO_HOME_PAGE_MODAL_OPEN
            );

            const isStandalone = () => {
                return window.matchMedia('(display-mode: standalone)').matches;
            };

            if (isPopUpOpened === null) {
                localStorageUtil.set(
                    ELocalStorageKeys.IS_SAVE_TO_HOME_PAGE_MODAL_OPEN,
                    true
                );
                setIsSaveToHomePageOpen(true);
            } else {
                setIsSaveToHomePageOpen(isPopUpOpened);
            }

            if (isStandalone()) {
                setIsSaveToHomePageOpen(false);
            }
        };

        checkSaveToHomePageStatus();
    }, [location]);

    const handleCloseSaveToHomePage = () => {
        localStorageUtil.set(
            ELocalStorageKeys.IS_SAVE_TO_HOME_PAGE_MODAL_OPEN,
            false
        );
        setIsSaveToHomePageOpen(false);
    };

    return {
        useSaveToHomePageNotification,
        isSaveToHomePageOpen,
        handleCloseSaveToHomePage,
        handleInstallApp
    };
};

export default useSaveToHomePage;
